// Requests
import PostCall from "./CommonApi";

export default function GetReceipt(props) {
  let url = "/v1/ovra/util/receipt/GenerateReceipt";
  let requestObject = props;

  return PostCall(url, requestObject);
}
